export default {
  getSubscription(state, data) {
    state.subscription.list = data || [];
  },
  subCounter(state, counter) {
    state.subscription.counter = counter;
  },
  getSubscriptionHistory(state, data) {
    state.subscription.history = data || [];
  },
  subTotal(state, counter) {
    state.subscription.total = counter;
  }
};
